function persianToEnglishNumber(persianNumber) {
    const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  
    for (let i = 0; i < 10; i++) {
      persianNumber = persianNumber.replace(new RegExp(persianNumbers[i], 'g'), englishNumbers[i]);
    }
  
    return persianNumber;
}

export default persianToEnglishNumber